import React from "react";
/** Components Import */
import { Modal, Button } from "react-bootstrap";

function Dialog({
  className = "",
  headerClassName = "",
  titleClassName = "",
  bodyClassName = "",
  footerClassName = "",
  closeButtonClassName = "",
  sumitButtonClassName = "",
  size = "md", // 'sm' | 'md' | 'lg' | 'xl'
  centered = true,
  animation = true,
  backdrop = true, // 'static' | true | false
  fullscreen = false, // true | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down'
  title = "",
  header = true,
  headerCloseButton = false,
  show = false,
  children, // Component
  footer = true,
  footerChildren, // Component
  closeButton = true,
  closeButtonName = "닫기",
  sumitButton = true,
  sumitButtonName = "저장",
  onClose = () => {}, // 닫을때 추가 하고 싶으면 쓰는 이벤트
  onHide = () => {}, // 닫기 이벤트
  onSumit = () => {},
}) {
  const CloseDialog = () => {
    onClose();
    onHide();
  };

  return (
    <Modal className={className} size={size} centered={centered} animation={animation} backdrop={backdrop} fullscreen={fullscreen} show={show} onHide={CloseDialog}>
      {header && (
        <Modal.Header className={headerClassName} closeButton={headerCloseButton}>
          <Modal.Title className={titleClassName}>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className={bodyClassName}>{children}</Modal.Body>
      {footer && (
        <Modal.Footer className={footerClassName}>
          {footerChildren}
          {sumitButton && (
            <Button className={sumitButtonClassName} onClick={onSumit}>
              {sumitButtonName}
            </Button>
          )}
          {closeButton && (
            <Button className={closeButtonClassName} onClick={CloseDialog}>
              {closeButtonName}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default Dialog;
